// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-mostrar {
	display: none;
}
.contenedor {
	margin-left: 8px
}
.margen-boton-input{
	margin-left: 5px
}
.boton{
	min-width: 120px;
}
.ancho-100{
	width: 90%;
	align-self: center;
	margin-top: 8px;
}
.imagen{
	width: 200px;
	align-self: center;

}

.fa.fa-search{
	font-size: 15px;
    position: relative;
    top: -2px;
}

`, "",{"version":3,"sources":["webpack://./src/app/directivas/components/file-select/file-select.component.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;AACA;CACC;AACD;AACA;CACC;AACD;AACA;CACC,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,YAAY;CACZ,kBAAkB;;AAEnB;;AAEA;CACC,eAAe;IACZ,kBAAkB;IAClB,SAAS;AACb","sourcesContent":[".no-mostrar {\r\n\tdisplay: none;\r\n}\r\n.contenedor {\r\n\tmargin-left: 8px\r\n}\r\n.margen-boton-input{\r\n\tmargin-left: 5px\r\n}\r\n.boton{\r\n\tmin-width: 120px;\r\n}\r\n.ancho-100{\r\n\twidth: 90%;\r\n\talign-self: center;\r\n\tmargin-top: 8px;\r\n}\r\n.imagen{\r\n\twidth: 200px;\r\n\talign-self: center;\r\n\r\n}\r\n\r\n.fa.fa-search{\r\n\tfont-size: 15px;\r\n    position: relative;\r\n    top: -2px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
